import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import styles from 'sections/DigitalTools/TrackingSystem/components/SectionIntegration/SectionIntegration.module.scss';

const cn = classNames.bind(styles);

const SectionIntegration = (): ReactElement => {
  return (
    <section className={cn('integration')}>
      <div className={cn('container')}>
        <div className={cn('integration__image-box')}>
          <img
            className={cn('integration__image')}
            src="/images/pages/DigitalTools/TrackingSystem/tracking-system-safari.png"
            alt="Container Tracking System in China"
          />
        </div>
        <div className={cn('integration__title-box')}>
          <h2 className={cn('integration__title')}>Web integration</h2>
          <div className={cn('integration__title-description')}>
            Offer your customers the convenience of tracking their shipments directly on your website, without the
            need to navigate to other sources. Gain easy access to shipping data from major carriers and enhance your
            company's services by integrating Tracking System features.
          </div>
        </div>
      </div>
    </section>
  );
};

export default SectionIntegration;